"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageSchema = void 0;
const yup = __importStar(require("yup"));
const linkSchemas = __importStar(require("../link/Link.schema"));
const schemaUtils_1 = require("../schemaUtils");
exports.ImageSchema = schemaUtils_1.createDataSchema('Image', yup.object({
    link: schemaUtils_1.createDataRef(linkSchemas).nullable(),
    title: yup.string().default('').max(100),
    name: yup.string().max(100),
    uri: yup.string().default(''),
    description: yup.string().max(1200),
    height: yup.number().default(200),
    width: yup.number().default(200),
    borderSize: yup.string(),
    alt: yup.string().default(''),
    originalImageDataRef: yup
        .string()
        .nullable()
        .meta({ description: 'Original Image before edit' }),
    opacity: yup.number(),
    crop: yup
        .object({
        x: yup.number().min(0),
        y: yup.number().min(0),
        width: yup.number().min(0),
        height: yup.number().min(0),
        svgId: yup.string().meta({
            description: 'Defines an svg uri for a mask inside the crop boundaries',
        }),
        flip: yup
            .mixed()
            .oneOf(['x', 'y', 'xy', 'none'])
            .meta({
            description: 'Defines whether the mask is flipped on the v or h axis',
        }),
        rotate: yup
            .number()
            .min(0)
            .max(360)
            .meta({ description: 'Defines a rotation angle for the mask' }),
    })
        .notRequired()
        .default(undefined),
    upscaleMethod: yup.string().meta({
        description: 'used for upscaling method when building an image url , expected values default|super',
    }),
    focalPoint: yup
        .object({
        x: yup.number().min(0).max(100),
        y: yup.number().min(0).max(100),
    })
        .notRequired()
        .default(undefined),
    artist: yup.object({ name: yup.string(), id: yup.string() }),
}));
//# sourceMappingURL=Image.schema.js.map